import { safeLocalStorageGet, safeLocalStorageSet } from "@/lib/safe-browser";

// Lightweight debug logger for stop-order changes during route rendering.
//
// Enable in the browser by either:
//   localStorage.setItem("routify_debug_order", "1")
// or visiting any page with ?debug=order in the URL (auto-persists for the tab).
//
// Disable with:
//   localStorage.removeItem("routify_debug_order")
//
// Logs are grouped under the "[order]" prefix so they're easy to filter in
// DevTools (filter the console by "[order]").

let cached: boolean | null = null;

export function isOrderDebugEnabled(): boolean {
  if (typeof window === "undefined") return false;
  if (cached !== null) return cached;
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get("debug") === "order") {
      safeLocalStorageSet("routify_debug_order", "1");
    }
    cached = safeLocalStorageGet("routify_debug_order") === "1";
  } catch {
    cached = false;
  }
  return cached;
}

export function orderLog(scope: string, message: string, data?: Record<string, unknown>) {
  if (!isOrderDebugEnabled()) return;
  const ts = new Date().toISOString().slice(11, 23);
  // eslint-disable-next-line no-console
  console.log(`[order ${ts}] (${scope}) ${message}`, data ?? "");
}

export function orderWarn(scope: string, message: string, data?: Record<string, unknown>) {
  if (!isOrderDebugEnabled()) return;
  const ts = new Date().toISOString().slice(11, 23);
  // eslint-disable-next-line no-console
  console.warn(`[order ${ts}] (${scope}) ${message}`, data ?? "");
}
